import { render, staticRenderFns } from "./DashboardCardComponent.vue?vue&type=template&id=2706fc99&scoped=true"
import script from "./DashboardCardComponent.vue?vue&type=script&lang=js"
export * from "./DashboardCardComponent.vue?vue&type=script&lang=js"
import style0 from "./DashboardCardComponent.vue?vue&type=style&index=0&id=2706fc99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2706fc99",
  null
  
)

export default component.exports